// extracted by mini-css-extract-plugin
export default {"dropdownButton":"SalesPerPlatform_dropdownButton__R1wE7","dropdown-menu":"SalesPerPlatform_dropdown-menu__7BJnT"};